import { translate } from '@/translation/native_translate';

const requiredRules = [(v) => {
  if (!!v === false) {
    return translate('FIELD_REQUIRED');
  }

  if (typeof v === 'object') {
    if (Array.isArray(v)) {
      // Array
      if (v.length === 0) {
        // Empty array
        return translate('FIELD_REQUIRED');
      }
    } else if (Object.keys(v).length === 0) {
      // Empty object
      return translate('FIELD_REQUIRED');
    }
  }

  return true;
}];

const websiteRules = [
  (v) => (v != null && v.match(
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
  ) != null) || translate('INVALID_WEBSITE'),

  (v) => (v != null && v.length < 1024) || translate('FIELD_MAX_LENGTH_1024'),
];

const emailRules = [
  (v) => (v != null && v.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ) != null) || translate('INVALID_EMAIL'),

  (v) => (v != null && v.length < 64) || translate('FIELD_MAX_LENGTH_64'),
];

const textRulesTo45 = [
  (v) => !!v || translate('FIELD_REQUIRED'),
  (v) => v.length < 45 || translate('FIELD_MAX_LENGTH_45'),
  (v) => v.match(/[^a-zA-Z0-9 ]+/) == null || translate('FIELD_NO_SPECIAL_CHARS'),
];

const optionalTextRulesTo128 = [
  (v) => v.length < 128 || translate('FIELD_MAX_LENGTH_45'),
  (v) => v.match(/[^a-zA-Z0-9 ]+/) == null || translate('FIELD_NO_SPECIAL_CHARS'),
];

const optionalTextRulesTo32 = [
  // v => !!v || translate("FIELD_REQUIRED"),
  (v) => (v && v.length < 32) || translate('FIELD_MAX_LENGTH_32'),
  (v) => (v && v.match(/[^a-zA-Z0-9 ]+/)) == null || translate('FIELD_NO_SPECIAL_CHARS'),
];

const phoneNumberRules = [
  (v) => (v != null && v.match(
    /^((\+|00(\s|\s?-\s?)?)31(\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/,
  ) != null) || translate('PHONE_NO_RECOGNITION'),
];

export {
  requiredRules,
  websiteRules,
  emailRules,
  textRulesTo45,
  optionalTextRulesTo128,
  optionalTextRulesTo32,
  phoneNumberRules,
};
